import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { OrderService } from 'src/app/services/order/order.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-allorders',
  templateUrl: './allorders.component.html',
  styleUrls: ['./allorders.component.css']
})
export class AllordersComponent implements OnInit {

  data: any;

  constructor(private orderServices: OrderService, private router: Router) { }

  ngOnInit() {
    this.getOrderList();
  }

  getOrderList() {
    this.orderServices.getAllOrderList().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  ViewOrder(orderno : string)
  {
    if (orderno != null) {
      this.router.navigate(['/manageorder',orderno]);
    }
  }

}
